import { AfterContentInit, AfterViewInit, Component, OnInit } from '@angular/core';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';

@Component({
	selector: 'app-not-found',
	templateUrl: './not-found.component.html',
	styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements AfterViewInit {

	constructor() {}

	ngAfterViewInit(): void {
		setTimeout(() => {
			GlobalSettingsService.isGlobalLoaderLoading = false;
			GlobalSettingsService.isSecondaryLoaderLoading = false;
		}, 0);
	}
}
